import { apiEndpoints, apiPath, CommandResult, IncidentType, OrganizationOwner, PortalLoginOptions, PortalSharedDocumentView, PortalSharedResourceView, PortalSharedSurveyReportView, SharedSurveyReport, WorkgroupListing } from '../amorg-common';
import { commandAuthWrapper, portalCommandAuthWrapper, portalQueryAuthWrapper, queryAuthWrapper } from './serverApiHelpers';

export const portalClientApi = {

    getLoginOptions: async (siteId: string): Promise<PortalLoginOptions> =>
        await queryAuthWrapper(apiEndpoints.portal_login_siteId_options.replace(':siteId', siteId)),

    requestMagicLink: async (siteIdOrLoginName:string, email:string): Promise<CommandResult> =>
        await commandAuthWrapper(apiEndpoints.portal_login_siteId_magicLink_request.replace(':siteIdOrLoginName', siteIdOrLoginName), 'POST',
            { email }),

    confirmMagicLink: async (siteId:string, email:string, requestId:string): Promise<boolean> =>
    {
         const response = await fetch(apiEndpoints.portal_login_siteId_magicLink_confirm.replace(':siteId', siteId).replace(':email', email).replace(':requestId', requestId),
            {
                method:'GET',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            return response.status === 200;
    },

    createIncident: async (
        id: string,
        type: IncidentType,
        title: string,
        description: string,
        solutionDescription: string,
        anonymousSelected: boolean,
        email: string,
        name: string,
        notificationsSelected: boolean,
        fileUploadSlotId = ''
    ): Promise<CommandResult> =>
        await portalCommandAuthWrapper(`${apiEndpoints.incidents_type.replace(':type', type)}`, 'POST',
            { id, type, title, description, solutionDescription, anonymousSelected, email, name, notificationsSelected, fileUploadSlotId }),

    getPortalSharedResources: async (): Promise<PortalSharedResourceView[]> =>
        await portalQueryAuthWrapper(apiEndpoints.portal_shared_resources) as PortalSharedResourceView[],

    getPortalFiles: async (): Promise<PortalSharedDocumentView[]> =>
    {
        const resources = await portalQueryAuthWrapper(apiEndpoints.portal_shared_resources) as PortalSharedResourceView[];
        return resources
            .filter(resource => resource.resourceType === 'DocumentArchiveFile')
            .map(resource => ({
                ...resource,
                created: new Date(resource.created)
            }));
    },

    getPortalSurveyReports: async (surveyId:string): Promise<PortalSharedSurveyReportView[]> =>
    {
        const resources = await portalQueryAuthWrapper(apiEndpoints.portal_shared_resources) as PortalSharedResourceView[];
        return resources
            .filter(resource => resource.resourceType === 'SurveyReport' && resource.resourceId === surveyId)
            .map(resource => ({
                ...resource,
            }) as PortalSharedSurveyReportView);
    },

    getPortalSurveyReport: async (resourceId:string): Promise<SharedSurveyReport | null> =>
    {
        return await portalQueryAuthWrapper(apiEndpoints.portal_shared_survey_report.replace(':portalResourceId', resourceId)) as SharedSurveyReport | null;
    },

    getOwner: async (): Promise<OrganizationOwner> =>
        await portalQueryAuthWrapper(`${apiPath}/organizationsettings/owner`),

    getWorkgroups: async (): Promise<WorkgroupListing[]> =>
        await portalQueryAuthWrapper(`${apiPath}/workgroups`),

    accessKeyLogin: async (siteId:string, accessKey:string): Promise<boolean> =>
    {
         const response = await fetch(apiEndpoints.portal_access_key_siteId_accessKey.replace(':siteId', siteId).replace(':accessKey', accessKey),
            {
                method:'GET',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            return response.status === 200;
    }
}